import { Auth0VueClientOptions, createAuth0 } from '@auth0/auth0-vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@/index.scss'

// plugins
import VueClickAway from 'vue3-click-away'
import SkynamoTooltip from '@shared/design-system/plugins/SkynamoTooltip'

// components
import App from '@/App.vue'
import { createAuthorizationParameters } from '@shared/helpers/AuthorizationParametersHelper'
import { setSharedRouter } from '@shared/services/router'
import { RouterSingleton } from './router/RouterSingleton'

const auth0Domain = process.env.AUTH0_DOMAIN
const auth0ClientId = process.env.AUTH0_CLIENT_ID
if (!auth0Domain) {
  throw Error(`AUTH0_DOMAIN was not provided or invalid: ${process.env.AUTH0_DOMAIN}`)
}
if (!auth0ClientId) {
  throw Error(`AUTH0_CLIENT_ID was not provided or invalid: ${process.env.AUTH0_CLIENT_ID}`)
}

const options = createAuth0Options(auth0Domain, auth0ClientId)

function createAuth0Options(domain: string, clientId: string): Auth0VueClientOptions {
  return {
    domain: domain,
    clientId: clientId,
    authorizationParams: createAuthorizationParameters({
      audience: process.env.AUTH0_AUDIENCE,
      redirect_uri: window.location.origin,
      source: 'main defaultOptions',
    }),
  }
}

const router = RouterSingleton.getRouter()
setSharedRouter(router)
const app = createApp(App)

app
  .use(createPinia())
  .use(router)
  .use(createAuth0(options))
  .use(VueClickAway)
  .use(SkynamoTooltip)
  .mount('#app')
